import React from "react";

interface EmptyStateProps {
    title?: string;
    description?: string;
    icon?: string;
    action?: {
        label: string;
        onClick: () => void;
    };
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    title = "No tasks found",
    description = "Get started by creating your first task",
    icon = "fa-clipboard-list",
    action,
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-6">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center mb-6">
                <i className={`fas ${icon} text-3xl text-slate-400`} />
            </div>
            <h3 className="text-lg font-semibold text-slate-800 mb-2">
                {title}
            </h3>
            <p className="text-sm text-slate-500 text-center max-w-sm mb-6">
                {description}
            </p>
            {action && (
                <button
                    onClick={action.onClick}
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-slate-800 transition-colors"
                >
                    <i className="fas fa-plus text-xs" />
                    {action.label}
                </button>
            )}
        </div>
    );
};
